import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_cultura_etapa } from "../../../models";

export const CulturaEtapa = () => {
    const columns = [
        { field: 'cultetid', header: 'Código', style: { width: '300px' } },
        { field: 'cultdescricao', header: 'Cultura', style: { width: '300px' } },
        { field: 'cultetdescricao', header: 'Descrição' },
        { field: 'cultetsequencia', header: 'Sequência' },
        { field: 'functions', style: { minWidth: '2rem', width: '2rem' } }
    ];

    return (
        <ConsultaPadrao model={model_cultura_etapa} columns={columns} sortField="cultetdescricao" />
    )
}